module.exports = __webpack_public_path__ + "assets/advantages-benefits-50055f.svg";